import { supabase } from './supabase'

export async function trackEvent(eventName: string, eventData: Record<string, any> = {}) {
  try {
    const { data: { session } } = await supabase.auth.getSession()
    if (!session?.user) return // Don't track anonymous events

    const { error } = await supabase
      .from('user_events')
      .insert({
        user_id: session.user.id,
        event_name: eventName,
        event_data: eventData
      })

    if (error) {
      console.error('[Analytics] Error tracking event:', error)
    }
  } catch (err) {
    console.error('[Analytics] Exception tracking event:', err)
  }
}
